(function () {
  function applyFix() {
    if (!window.cart) return;
    var el = document.querySelector('[data-free-shipping][data-currency-is-target="true"]');
    if (!el) return;
    var limitDollars = Number(el.getAttribute('data-free-shipping-limit'));
    if (!limitDollars) return;
    window.cart.freeShippingLimit = limitDollars * 100;
    if (typeof window.cart.updateProgress === 'function') {
      window.cart.updateProgress();
    }
  }

  window.addEventListener('load', applyFix);
  document.addEventListener('theme:cart:add', function () {
    setTimeout(applyFix, 50);
  });
  document.addEventListener('theme:announcement:init', applyFix);
})();
